var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3625_29980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 10.5C10.5774 10.5 12.6667 8.41062 12.6667 5.83329C12.6667 3.25596 10.5774 1.16663 8.00004 1.16663C5.42271 1.16663 3.33337 3.25596 3.33337 5.83329C3.33337 8.41062 5.42271 10.5 8.00004 10.5Z",
    stroke: "#848491",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47329 9.75996L4.66663 15.8333L7.99996 13.8333L11.3333 15.8333L10.5266 9.7533",
    stroke: "#848491",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3625_29980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.efc27b0eee00856f0a52e065183b8911.svg";
export { ForwardRef as ReactComponent };